var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InputComponent',_vm._b({attrs:{"disabled":"","value":_vm.result}},'InputComponent',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }